import { render, staticRenderFns } from "./FormSuccessB.vue?vue&type=template&id=0d5084fc"
import script from "./FormSuccessB.vue?vue&type=script&lang=js"
export * from "./FormSuccessB.vue?vue&type=script&lang=js"
import style0 from "./FormSuccessB.vue?vue&type=style&index=0&id=0d5084fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports